export default __webpack_public_path__ + "static/media/oku@2x.78506015.png";